import DashboardClickFileIconSVG from "assets/svg/dashboard-click-file-icon";
import DashboardEyeIconSVG from "assets/svg/dashboard-eye-icon";
import DashboardInteractionIconSVG from "assets/svg/dashboard-interaction-icon";
import { useReport } from "utils/reports";
import StatisticsDashboard from "./statistics-dashboard/statistics-dashboard";

export default function TotalStats({ dateLabel, start, end, params = {} }) {
  const { report, isLoading, isError } = useReport(start, end, params);
  return (
    <div className="my-2 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
      <StatisticsDashboard
        icon={<DashboardEyeIconSVG />}
        total={report?.opens ?? 0}
        title="Visitors"
        message={dateLabel}
        loading={isLoading}
        error={isError}
      />
      <StatisticsDashboard
        icon={<DashboardClickFileIconSVG />}
        total={report?.clicks ?? 0}
        title="Opens"
        message={dateLabel}
        loading={isLoading}
        error={isError}
      />
      <StatisticsDashboard
        icon={<DashboardInteractionIconSVG />}
        total={report?.interactions ?? 0}
        title="Interactions"
        message={dateLabel}
        loading={isLoading}
        error={isError}
      />
    </div>
  );
}
